import React, { useEffect } from 'react';
import { ThemeProvider } from '../../../theme/ThemeContext';
import {
  Container,
  Tab,
  Tabs,
  Box
} from '@mui/material';
import '../../../App.css';
import { Outlet, useLocation, useNavigate } from 'react-router';

function DataPlatform() {
  const navigate = useNavigate();
  const location = useLocation();
  let lastLoc = location.pathname.split('/').pop(); // Watch out for this if the route structure changes
  if (lastLoc === 'dataplatform' || lastLoc === '') {
    lastLoc = 'logs';
  }

  useEffect(() => {
    if (location.pathname === '/app/dataplatform' || location.pathname === '/app/dataplatform/') {
      navigate('/app/dataplatform/logs', { replace: true });
    }
  }, [location.pathname, navigate]);

  const handleTabChange = (event, newValue) => {
    // Navigation is handled by the onClick on each Tab.
  };

  return (
    <ThemeProvider>
      <div className="App">
        <Container maxWidth={false} sx={{ width: '100%' }}>
          <h1>Data Viewer</h1>
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <Tabs value={lastLoc} onChange={handleTabChange}>
              <Tab label="Logs" value="logs" onClick={() => navigate("/app/dataplatform/logs")} />
              <Tab label="LFDs" value="lfds" onClick={() => navigate("/app/dataplatform/lfds")} />
              <Tab label="RAS Datasets" value="rasdsts" onClick={() => navigate("/app/dataplatform/rasdsts")} />
              {/* Datasets tab is disabled until needed and implemented.
                <Tab label="Datasets" value="datasets" onClick={() => navigate("/app/dataplatform/datasets")} /> */}
              <Tab label="Actuator Tests" value="actuator_test" onClick={() => navigate("/app/dataplatform/actuator_test")} />
              <Tab label="Agents" value="agents" onClick={() => navigate("/app/dataplatform/agents")} />
            </Tabs>
          </Box>
          <Container maxWidth={false} sx={{ width: '100%', p: 2 }}>
            <Outlet />
          </Container>
        </Container>
      </div>
    </ThemeProvider>
  );
}

export default DataPlatform;
